export default __webpack_public_path__ + "43f218c882ddc980fd39fdc83510bf5a.png";